import { isCheckoutUrl } from './UrlMatch';
import { Origins } from '../Config/Origin';

const GetOriginId = (sitioId, callback) => {
    const hasCheckoutCallback = callback && isCheckoutUrl(callback)
    if(!hasCheckoutCallback){
        return sitioId;
    }
    if(Origins.foodit == sitioId) return Origins.firstStepCheckoutFoodit;

    return Origins.firstStepCheckout;
};

export {
    GetOriginId
}
